export const FETCH_VOD_GET_HOMEPAGE_ROWS_REQUEST = 'FETCH_VOD_GET_HOMEPAGE_ROWS_REQUEST';
export const FETCH_VOD_GET_HOMEPAGE_ROWS_SUCCESS = 'FETCH_VOD_GET_HOMEPAGE_ROWS_SUCCESS';
export const FETCH_VOD_GET_HOMEPAGE_ROWS_FAILURE = 'FETCH_VOD_GET_HOMEPAGE_ROWS_FAILURE';

export const FETCH_VOD_GET_HOMEPAGE_ROW_ITEM_REQUEST = 'FETCH_VOD_GET_HOMEPAGE_ROW_ITEM_REQUEST';
export const FETCH_VOD_GET_HOMEPAGE_ROW_ITEM_SUCCESS = 'FETCH_VOD_GET_HOMEPAGE_ROW_ITEM_SUCCESS';
export const FETCH_VOD_GET_HOMEPAGE_ROW_ITEM_FAILURE = 'FETCH_VOD_GET_HOMEPAGE_ROW_ITEM_FAILURE';
